// Generated by purs version 0.15.16
var hashchange = "hashchange";
export {
    hashchange
};
//# sourceMappingURL=index.js.map
